import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
  align-items: center;
  width: 100%;

  ${mediaQueries.tablet} {
    flex-direction: row;
    width: auto;
  }
`
